import { render, staticRenderFns } from "./AvailableOrders.vue?vue&type=template&id=34e96871&scoped=true"
import script from "./AvailableOrders.vue?vue&type=script&lang=js"
export * from "./AvailableOrders.vue?vue&type=script&lang=js"
import style0 from "./AvailableOrders.vue?vue&type=style&index=0&id=34e96871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e96871",
  null
  
)

export default component.exports